<template>
  <div>
    <div class="voortgang" style="float:right;">
      <div class="voortgangholder">
        <!-- cirkel 1 -->
        <div v-if="opdracht.status == 'Nieuw'" class="circle">
          <div class="line"></div>
        </div>
        <div v-if="opdracht.status != 'Nieuw'" class="circle-check">
          <div class="line-check"></div>
        </div>

        <!-- Toegewezen cirkel -->
        <div v-if="opdracht.status == 'Toegewezen'" class="circle" style="background-color:#ff9326;">
          <div class="line" style="background-color:#ff9326;"></div>
        </div>

        <!-- cirkel 2 -->
        <div v-if="(opdracht.status != 'Uitgezet' && opdracht.status == 'In behandeling') || opdracht.status == 'Nieuw'" class="circle">
          <div class="line"></div>
        </div>
        <div
          v-if="
            opdracht.status != 'Toegewezen' &&
              opdracht.status != 'Nieuw' &&
              opdracht.status != 'In behandeling' &&
              opdracht.status != 'Geannuleerd'
          "
          class="circle-check"
        >
          <div class="line-check"></div>
        </div>

        <!-- cirkel 3 -->
        <div
          v-if="
            opdracht.status != 'Geaccepteerd' &&
              opdracht.status != 'Gestart' &&
              opdracht.status != 'Geaccepteerd' &&
              opdracht.status != 'Beëindigd'
          "
          class="circle"
        >
          <div class="line"></div>
        </div>
        <div
          v-if="
            opdracht.status == 'Gestart' ||
              opdracht.status == 'Geaccepteerd' ||
              (opdracht.status == 'Beëindigd' && opdracht.status != 'Geannuleerd')
          "
          class="circle-check"
        >
          <div class="line-check"></div>
        </div>

        <!-- cirkel 4 -->
        <div v-if="opdracht.status != 'Gestart' && opdracht.status != 'Beëindigd'" class="circle-heart">
          <div class="line"></div>
        </div>
        <div
          v-if="
            opdracht.status != 'Nieuw' &&
              opdracht.status != 'In behandeling' &&
              opdracht.status != 'Uitgezet' &&
              opdracht.status != 'Toegewezen' &&
              opdracht.status != 'Geaccepteerd' &&
              opdracht.status != 'Geannuleerd'
          "
          class="circle-heart-check"
        >
          <div class="line-check"></div>
        </div>

        <!-- cirkel 5 -->
        <div v-if="opdracht.status != 'Beëindigd'" class="square"></div>
        <div v-if="opdracht.status == 'Beëindigd' && opdracht.status != 'Geannuleerd'" class="square-check"></div>

        <!-- annuleer-kruis NIET -->
        <div v-if="opdracht.geannuleerd != true" class="geannuleerdnot"></div>

        <!-- annuleer-kruis -->
        <div v-if="opdracht.geannuleerd == true" class="geannuleerd"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Voortgang',
  props: {
    opdracht: Object
  }
};
</script>

<style scoped>
.voortgangtitlesholder {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 4px;
  overflow: visible;
}

.voortgangtitel {
  width: 10px;
  margin-right: 13px;
  margin-left: 7px;
  transform: rotate(-50deg);
  white-space: nowrap;
  font-size: 14px;
}

.voortgangholder {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  overflow: visible;
}

.circle {
  position: relative;
  width: 23px;
  height: 23px;
  margin-right: 14px;
  border-radius: 100px;
  background-color: #b8c3d5;
}

.circle-heart {
  position: relative;
  width: 24px;
  height: 23px;
  margin-right: 14px;
  background-image: url('../../assets/voortgang/heart-gray.png');
  background-position: center;
  background-size: 30px;
}
.circle-heart-check {
  position: relative;
  width: 24px;
  height: 23px;
  margin-right: 14px;
  background-image: url('../../assets/voortgang/heart-red.png');
  background-position: center;
  background-size: 30px;
}

.circle-check {
  position: relative;
  width: 23px;
  height: 23px;
  margin-right: 14px;
  border-radius: 100px;
  background-color: #3076ea;
}

.square {
  position: relative;
  width: 19px;
  height: 19px;
  margin-right: 14px;
  /* border-radius: 100px; */
  background-color: #b8c3d5;
  transform: rotate(45deg);
}
.square-check {
  position: relative;
  width: 19px;
  height: 19px;
  margin-right: 14px;
  border-radius: 100px;
  background-color: #35dd83;
  transform: rotate(45deg);
}

.geannuleerd {
  position: relative;
  width: 30px;
  height: 30px;
  margin-right: 14px;
  background-image: url('../../assets/voortgang/geannuleerd-ico.png');
  background-position: center;
  background-size: 30px;
}

.geannuleerdnot {
  position: relative;
  width: 30px;
  height: 30px;
  margin-right: 14px;
  background-image: url('../../assets/voortgang/geannuleerd-ico.png');
  background-position: center;
  background-size: 30px;
  filter: grayscale();
  opacity: 0.5;
  cursor: pointer;
}

.line {
  position: absolute;
  left: auto;
  top: 50%;
  right: -18px;
  bottom: auto;
  width: 20px;
  height: 4px;
  background-color: #b8c3d5;
  transform: translate(0px, -50%);
}
.line-check {
  position: absolute;
  left: auto;
  top: 50%;
  right: -18px;
  bottom: auto;
  width: 20px;
  height: 4px;
  background-color: #3076ea;
  transform: translate(0px, -50%);
}
</style>
